import { Col, Row, Space, Typography, Button } from "antd";
import { FC, useContext, useEffect, useState } from "react";
import { useTheme } from "../../../Styles/ThemeHook";
import { useUser } from "shared-components/Components/User/User.hook";
import { CountryCode, getCountryCallingCode } from "libphonenumber-js";
import { useContactModal } from "shared-components/Contexts/ContactModal/context";
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";
import { getInitialContactForm } from "src/utils/Functions";

type ExtraAskFields = {
	name?: string;
	email?: string;
	phone?: string;
};

type onAskFunction = (field: string, { name, email, phone }?: ExtraAskFields) => Promise<Object>;

interface TechnicalItemProps {
	field: string;
	text: string;
	value: string;
	onAsk: onAskFunction;
	showSimilars: Function;
	isDisabledProperty?: boolean;
	isMono?: boolean;
}

export const TechnicalItem: FC<TechnicalItemProps> = ({
	field,
	text,
	value,
	onAsk,
	showSimilars = null,
	isDisabledProperty = false,
	isMono = false,
}) => {
	const { theme } = useTheme();
	const {
		isLoggedIn,
		user: { data: dataUser },
	} = useUser();
	const { openContactModal, closeContactModal } = useContactModal();
	const { country_code } = useContext(ConfigStateContext);
	const [asked, setAsked] = useState(false);
	const [selectedCountryCode, setSelectedCountryCode] = useState({
		code: "",
		value: "",
	});

	const askFastAction = async field => {
		let res = await onAsk(field);
		if (res) {
			setAsked(true);
			if (showSimilars) {
				showSimilars();
			}
		}
	};

	value = field == 'bedrooms' && isMono ? "Monoambiente" : value;

	const handleClick = async (e: MouseEvent) => {
		e.preventDefault();
		e.stopPropagation();
		const dataModal = getInitialContactForm(isLoggedIn, dataUser);

		let res = await onAsk(field, {
			name: dataModal.name,
			phone: selectedCountryCode.value + dataModal.phone,
			email: dataModal.email,
		});

		if (res) {
			setAsked(true);
			closeContactModal();

			if (showSimilars) {
				showSimilars();
			}
		}
	};


	useEffect(() => {
		if (country_code) {
			setSelectedCountryCode({
				code: country_code as CountryCode,
				value: `+${getCountryCallingCode(country_code as CountryCode)}`,
			})
		}
	}, [country_code]);

	const SpanAskFast = ({ field }) => {
		if (asked) {
			return <Typography.Text disabled>{"¡Preguntado!"}</Typography.Text>;
		} else {
			return (
				<button
					disabled={isDisabledProperty}
					onClick={() => {
						if (!isDisabledProperty) {
							if (!isLoggedIn) {
								openContactModal({
									id: value,
									owner: null,
									isProject: false,
									projectId: null,
									defaultMessage: "",
									source: "propertyDetail",
									isExpress: true,
									expressCallback: (e) => handleClick(e),
									ctaToShow: {
										contact: true,
										phone: false,
										whatsapp: false
									}
								})
							} else {
								askFastAction(field);
							}
						} else {
							null;
						}
					}}
					className="btnQuestion"
				>
					{"¡Pregúntale!"}
				</button>
			);
		}
	};

	const showLabel= ()=>{
		if ((field === "bathrooms" || field === "rooms") && value === "0") return false // si es baño o ambiente en 0 dirá "¡Pregúntale!" en vez de 0
		else if (value && value != null) return true
		return false
	}

	return (
		<Row key={field} gutter={theme.spacing.mdSpacing} justify="space-between">
			<Col>
				<Space size={theme.spacing.xsSpacing}>
					<Typography.Text type={"secondary"} className="small">
						•{" "}
					</Typography.Text>
					<Typography.Text>{text}</Typography.Text>
				</Space>
			</Col>
			<Col flex={1} className="dots" />
			<Col>
				{showLabel() ? (
					<Typography.Paragraph
						strong
						title={value}
						style={{ margin: 0 }}
						ellipsis={{ rows: 2 }}>
						{value}
					</Typography.Paragraph>

				) : (
					<SpanAskFast field={field} />
				)}
			</Col>
		</Row>
	);
};

